export const mockPublicVacancy = {
  vacancy_title: 'Senior Frontend Developer',
  company_name: 'Starec AI',
  description: `## О компании

Starec AI — продуктовая технологическая компания, разрабатывающая AI-платформу для HR-отделов. Наш продукт помогает компаниям автоматизировать подбор персонала с помощью искусственного интеллекта.

## О задаче

Мы ищем опытного Frontend-разработчика, который возглавит развитие клиентской части нашей платформы. Вы будете работать над сложным SaaS-продуктом, которым пользуются десятки компаний.

## Чем предстоит заниматься

• Разработка и поддержка веб-приложения на React 19 + TypeScript
• Проектирование архитектуры frontend-части платформы
• Оптимизация производительности и доступности интерфейсов
• Развитие дизайн-системы и компонентной библиотеки
• Менторинг junior-разработчиков
• Плотная работа с продуктовой командой

## Требования

• 4+ года коммерческой разработки на React
• Глубокое знание TypeScript, ES2024
• Опыт с state management (Redux, Zustand, Effector)
• Понимание SSR/SSG (Next.js)
• Умение писать unit и e2e тесты
• Опыт работы с CI/CD и Docker — плюс

## Условия

• Удалённая работа или офис в Москве (м. Деловой центр)
• Гибкий график, фокус на результат
• Оформление по ТК РФ или ИП/СЗ
• ЗП от 350 000 ₽ на руки (обсуждается по итогам собеседования)
• ДМС, обучение за счёт компании, конференции
• Современный MacBook Pro + монитор 4K`,
  salary_from: 350000,
  salary_to: 500000,
  location: 'Москва / удалённо',
  contact_email: 'hr@starec.ai',
  contact_telegram: '@starec_hr',
  show_contacts_on_landing: true,
  questions: [
    { id: 'q1', text: 'Расскажите о проекте, которым вы гордитесь. Какую конкретную задачу решали?' },
    { id: 'q2', text: 'Как вы предпочитаете работать: в большой команде или в маленькой?' },
    { id: 'q3', text: 'Опишите свою главную профессиональную слабость и как вы с ней работаете.' },
    { id: 'q4', text: 'Где вы видите себя через 3 года?' },
    { id: 'q5', text: 'Расскажите о ситуации, когда решали сложную техническую проблему в сжатые сроки.' },
    { id: 'q6', text: 'Что вас мотивирует в работе?' },
    { id: 'q7', text: 'Опишите ситуацию конфликта в команде. Как вы её разрешали?' },
  ],
  language: 'ru',
};

export const mockPublicJobs = [
  {
    slug: 'senior-frontend',
    title: 'Senior Frontend Developer',
    location: 'Москва / удалённо',
    salary_from: 350000,
    salary_to: 500000,
    status: 'active',
  },
  {
    slug: 'product-manager',
    title: 'Product Manager',
    location: 'Москва',
    salary_from: 300000,
    salary_to: 450000,
    status: 'active',
  },
  {
    slug: 'backend-lead',
    title: 'Backend Team Lead',
    location: 'Москва / удалённо',
    salary_from: 400000,
    salary_to: 600000,
    status: 'active',
  },
  {
    slug: 'ux-designer',
    title: 'UX Designer',
    location: 'Москва',
    salary_from: 200000,
    salary_to: 300000,
    status: 'active',
  },
  {
    slug: 'devops-engineer',
    title: 'DevOps Engineer',
    location: 'Удалённо',
    salary_from: 250000,
    salary_to: 400000,
    status: 'active',
  },
];